import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'formatReport',
    standalone: false
})
export class FormatReportPipe implements PipeTransform {

	constructor(private sanitizer: DomSanitizer) {}

	transform(rawText: string | undefined): SafeHtml {
		const formattedHtml = this.formatReportToHtml(rawText);
		return this.sanitizer.bypassSecurityTrustHtml(formattedHtml);
	}

	formatReportToHtml(reportText: string | undefined): string {
		if (!reportText) { return ''; }

		let reportBodyHtml = '';
		const lines = reportText.split('\n');
		let inList = false;

		for (const line of lines) {
			const strippedLine = line.trim();

			if (inList && !strippedLine.startsWith('* ')) {
				reportBodyHtml += '</ul>\n';
				inList = false;
			}
			
			if (strippedLine === '') { continue; }

			if (strippedLine.startsWith('#@ ') || strippedLine.startsWith('##@ ')) {
				continue; // Skip to the next line
			}

			if (strippedLine.startsWith('# ')) {
				reportBodyHtml += `<h1 class="report-main-title">${strippedLine.replace('# ', '')}</h1>\n`;
			} else if (strippedLine.startsWith('## ')) {
				reportBodyHtml += `<h2 class="section-title">${strippedLine.replace('## ', '')}</h2>\n`;
			} else if (strippedLine.startsWith('### ')) {
				reportBodyHtml += `<h3 class="report-subsection-title">${strippedLine.replace('### ', '')}</h3>\n`;
			}

			else if (strippedLine.startsWith('* ')) {
				if (!inList) {
					reportBodyHtml += '<ul class="report-list">\n';
					inList = true;
				}
				
				let listItemContent = strippedLine.substring(2).trim(); // Content after '* '
				listItemContent = listItemContent.replace(/\*\*(.*?)\*\*/g, '<span class="badge bg-primary-subtle text-primary-emphasis fs-16">$1</span>');
				
				reportBodyHtml += `<li>${listItemContent}</li>\n`;
			} else {
				const processedParagraph = strippedLine.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
				reportBodyHtml += `<p>${processedParagraph}</p>\n`;
			}
		}

		if (inList) {
			reportBodyHtml += '</ul>\n';
		}

		return reportBodyHtml;
	}

	formatReportToHtmlOld(reportText: string | undefined): string {
		if (!reportText) {
			return '';
		}

		let reportBodyHtml = '';
		const lines = reportText.split('\n');
		let inList = false; // State variable to manage lists

		for (const line of lines) {
			const strippedLine = line.trim();

			// Handle inline bolding first: **text** -> <strong>text</strong>
			let processedLine = strippedLine.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

			// If we are in a list and the new line is NOT a list item, close the list.
			if (inList && !processedLine.startsWith('* ')) {
				reportBodyHtml += '</ul>\n';
				inList = false;
			}
			
			// Skip empty lines
			if (strippedLine === '') {
				continue;
			}

			// --- Process Block-Level Elements ---
			if (processedLine.startsWith('#@ ')) {
				reportBodyHtml += `<h1 class='h-title'>${processedLine.replace('#@ ', '')}</h1>\n`;
			} else if (processedLine.startsWith('##@ ')) {
				reportBodyHtml += `<h5 class='h-subtitle'>${processedLine.replace('##@ ', '')}</h5>\n`;
			} else if (processedLine.startsWith('# ')) {
				reportBodyHtml += `<h1>${processedLine.replace('# ', '')}</h1>\n`;
			} else if (processedLine.startsWith('## ')) {
				reportBodyHtml += `<h2>${processedLine.replace('## ', '')}</h2>\n`;
			} else if (processedLine.startsWith('### ')) {
				reportBodyHtml += `<h3>${processedLine.replace('### ', '')}</h3>\n`;
			} else if (processedLine.startsWith('* ')) {
				if (!inList) {
					// Start a new list if we aren't already in one
					reportBodyHtml += '<ul>\n';
					inList = true;
				}
				// Add the list item, removing the '* ' marker
				reportBodyHtml += `<li>${processedLine.replace('* ', '')}</li>\n`;
			} else {
				// Handle regular paragraphs
				reportBodyHtml += `<p>${processedLine}</p>\n`;
			}
		}

		// Final check to close any list that's still open at the end
		if (inList) {
			reportBodyHtml += '</ul>\n';
		}

		return reportBodyHtml;
	}
}